import { colours, device, fonts, fontsLineHeight } from "@helpers";
import localFont from "next/font/local";
import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

export const Animations = `
  .fade-in {
    animation: fadeIn ease 1s;
    -webkit-animation: fadeIn ease 1s;
    -moz-animation: fadeIn ease 1s;
    -o-animation: fadeIn ease 1s;
    -ms-animation: fadeIn ease 1s;
  }

  @keyframes fadeIn {
    0% {
      opacity:0;
    }
    100% {
      opacity:1;
    }
  }

  .slide-left {
    width: 100vw;
    animation: slideLeft linear 1s;
    -webkit-animation: slideLeft linear 1s;
    -moz-animation: slideLeft linear 1s;
    -o-animation: slideLeft linear 1s;
    -ms-animation: slideLeft linear 1s;
  }

  @keyframes slideLeft {
    0% {
      transform: translateX(80%);
    }
    100% {
      transform: translateX(0%);
    }
  }

  .slide-right {
    width: 100vw;
    animation: slideRight linear 1s;
    -webkit-animation: slideRight linear 1s;
    -moz-animation: slideRight linear 1s;
    -o-animation: slideRight linear 1s;
    -ms-animation: slideRight linear 1s;
  }

  @keyframes slideRight {
    0% {
      transform: translateX(-80%);
    }
    100% {
      transform: translateX(0%);
    }
  }
`;

const inputStyle = `
  .form-checkbox {
    background-origin: border-box;
    border: 1px solid;

    :checked {
      background-image: url("checkbox.svg");
      background-size: 100% 100%;
    }
  }

  input {
    font-family: EuclidCircularA;
    outline: none;
    border: none;
    border-bottom: 1px solid ${colours.MIDNIGHT_BLUE};
    color: ${colours.MIDNIGHT_BLUE};
    font-size: 16px;
    background: transparent;
    -webkit-border-radius:0;

    @media (min-width: ${device.tablet}) and (max-width: ${device.desktopS}) {
      height: 38px;
      font-size: 26px;
    }

    @media (min-width: ${device.desktopS}) {
      font-size: 30px;
      height: 38px;
    }
  }

  label {
    color: ${colours.MIDNIGHT_BLUE};
    font-family: var(--euclid-light);
    font-size: 12px;
    box-sizing: border-box;
    @media (min-width: ${device.laptop}) {
      font-size: 14px;
    }
  }

  input::-webkit-input-placeholder {
    font-size: 20px;
    font-family: EuclidCircularA;

    @media (min-width: ${device.desktopS}) {
      font-size: 28px;
    }
  }

  input:-ms-input-placeholder {
    font-size: 20px;
    font-family: EuclidCircularA;

    @media (min-width: ${device.desktopS}) {
      font-size: 28px;
    }
  }

  input:-moz-placeholder {
    font-size: 20px;
    font-family: EuclidCircularA;

    @media (min-width: ${device.desktopS}) {
      font-size: 28px;
    }
  }

  input::-moz-placeholder {
    font-size: 20px;
    font-family: EuclidCircularA;

    @media (min-width: ${device.desktopS}) {
      font-size: 28px;
    }
  }
`;

const modalStyle = `
div.full-size-modal {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.97);
  z-index: 100;
}
`;

const buttonStyle = `
button {
  align-items: center;
  background-color: ${colours.MIDNIGHT_BLUE};
  border-radius: 12px;
  border: 2px solid ${colours.MIDNIGHT_BLUE};
  box-sizing: border-box;
  color: ${colours.WHITE};
  display: flex;
  font-family: var(--euclid-medium);
  font-size: ${fonts.BUTTON};
  line-height: ${fontsLineHeight.A};
  justify-content: center;
  outline: none;
  padding: 13px 32px;
  min-width: 193px;
  width: 100%;
  transition: 0.2s;
  @media (min-width: 428px) {
    width: fit-content;
  }
  :hover {
    cursor: pointer;
    border: 2px solid ${colours.MIDNIGHT_BLUE} !important;
    background-color: ${colours.WHITE};
    color: ${colours.MIDNIGHT_BLUE} !important;
  }
  :disabled {
    opacity: 0.5;
  }
  :hover:enabled {
    cursor: pointer;
  }
  :active {
    transition: 0.3s all;
    transform: translateY(3px);
  }
}
`;

const iconStyle = `

[class^="icon-"], [class*=" icon-"] {
  /* use to prevent issues with browser extensions that change fonts */
  font-family: 'icons';
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`;
const checkboxStyle = `
.checkbox {
  display: inline-flex;
  cursor: pointer;
  position: relative;
}

.checkbox > input {
  height: 17px;
  width: 17px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  border: 1px solid ${colours.MIDNIGHT_BLUE};
  border-radius: 4px;
  outline: none;
  transition-duration: 0.3s;
  cursor: pointer;

  @media (min-width: ${device.tablet}) and (max-width: ${device.desktopS}) {
    height: 20px;
    width: 20px;
  }

  @media (min-width: ${device.desktopS}) {
    height: 30px;
    width: 30px;
  }

}

.checkbox > input:checked {
  border: 1px solid ${colours.PEACH};
  background-color: ${colours.PEACH};
}

.checkbox > input:checked::before {
  content: "\\2713";
  color: ${colours.WHITE};
  font-size: 17px;
  height: 17px;
  width: 17px;
  position: absolute;
  bottom: 2px;
  left: 1px;

  @media (min-width: ${device.tablet}) and (max-width: ${device.desktopS}) {
    font-size: 20px;
    height: 20px;
    width: 20px;
  }

  @media (min-width: ${device.desktopS}) {
    font-size: 30px;
    height: 30px;
    width: 30px;
  }
}

`;

export const sharedStyle = `
  html {
    box-sizing: border-box;
    scroll-behavior: smooth;
  }

  ${iconStyle}
`;

export const GlobalStyle = createGlobalStyle`
  ${reset}
  ${Animations}
  ${buttonStyle}
  ${modalStyle}
  ${inputStyle}
  ${checkboxStyle}
  ${sharedStyle}

  html {
    font-size: 16px;
    box-sizing: border-box;
    scroll-behavior: smooth;
  }
 

  body {
    line-height: 1.5;
    letter-spacing: 0;
  }
  .Layout {
  /* width: 100%;
  height: 100vh;
  box-sizing: border-box;
  max-width: 2560px;
  min-width: 100%; */
  position: relative;
    width: 100%;
    max-width: 2560px;
    display: flex;
    flex-direction: column;
    -webkit-box-pack: center;
    justify-content: center;
    margin: auto;
  & > div {
    margin-bottom: 30px;
  }

  /* & > div:nth-last-child(2) {
    margin-top: -30px;
  }
  & > div:nth-last-child(1) {
    margin-top: -30px;
  } */
  & > div > div > p:last-child {
    padding-bottom: 0px;
  }
  @media (min-width: ${device.tablet}) {
    & > div {
      margin-bottom: 60px;
    }
    /* & > div:nth-last-child(2) {
      margin-top: -60px;
    }
    & > div:nth-last-child(1) {
      margin-top: -60px;
    } */
  }
  }
  main > div {
    max-width: 2560px;
  }

  h1 {
    box-sizing: none;
    font-family: var(--taviraj-light);
    font-size: ${fonts.H1};
    line-height: ${fontsLineHeight.H1};
    color: ${colours.MIDNIGHT_BLUE};
    background-color: transparent;
  }

  h2 {
    font-family: var(--taviraj-light);
    font-size: ${fonts.H2};
    line-height: ${fontsLineHeight.H2};
    color: ${colours.MIDNIGHT_BLUE};
    background-color: transparent; 
  }

  h3 {
    font-family: var(--euclid-medium);
    font-size: ${fonts.H3};
    line-height: ${fontsLineHeight.H3};
    color: ${colours.MIDNIGHT_BLUE};
    background-color: transparent; 
  }

  h4 {
    font-family: var(--taviraj-light);
    color: ${colours.MIDNIGHT_BLUE};
    font-size: ${fonts.H4};
    line-height: ${fontsLineHeight.H4};
  }

  h5 {
    font-family: var(--euclid-regular);
    color: ${colours.MIDNIGHT_BLUE};
    font-size: ${fonts.H5};
    line-height: ${fontsLineHeight.H5};
  }

  h6 {
    font-family: var(--euclid-regular);
    color: ${colours.MIDNIGHT_BLUE};
    font-size: ${fonts.H6};
    line-height: ${fontsLineHeight.H6};
  }

  caption {
    font-family: var(--euclid-regular);
    color: ${colours.MIDNIGHT_BLUE};
    font-size: ${fonts.CAPTION};
    line-height: ${fontsLineHeight.CAPTION};
  }

  small {
    font-family: var(--euclid-regular);
    font-size: 16px;
    line-height: 23px;
    color: ${colours.MIDNIGHT_BLUE};

    @media (min-width: ${device.laptop}) {
      font-size: 18px;
      line-height: 26px;
    }
  }

  ul {
    font-family: inherit;
    list-style-type: disc;
    font-size: inherit;
  }

  ol {
    font-family: inherit;
    font-size: inherit;
    list-style-type: none;

    > li {
      counter-increment: item;
      display: flex;
      flex-direction: row;
      margin-left: 4px;
    }

    > li:before {
      min-width: 36px;
      content: counter(item) ". ";
      font-weight: bold;
    }
  }

  li {
    font-size: inherit;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 20px;
  }

  hr {
    border-top: 1px solid ${colours.MIDNIGHT_BLUE};
  }

  button {
    align-items: center;
    background-color: ${colours.MIDNIGHT_BLUE};
    border-radius: 12px;
    border: 2px solid ${colours.MIDNIGHT_BLUE};
    box-sizing: border-box;
    color: ${colours.WHITE};
    display: flex;
    font-family: var(--euclid-medium);
    font-size: ${fonts.BUTTON};
    line-height: ${fontsLineHeight.A};
    justify-content: center;
    outline: none;
    padding: 11px 32px;
    min-width: 193px;
    width: 100%;
    transition: 0.2s;
    @media (min-width: 428px) {
      width: fit-content;
    }
    :hover {
      cursor: pointer;
      border: 2px solid ${colours.MIDNIGHT_BLUE} !important;
      background-color: ${colours.WHITE};
      color: ${colours.MIDNIGHT_BLUE} !important;
    }
    :disabled {
      opacity: 0.5;
    }
    :hover:enabled {
      cursor: pointer;
    }
    :active {
      transition: 0.3s all;
      transform: translateY(3px);
    }
  }

  a, span, p, li, text {
    font-family: var(--euclid-regular);
    font-size: ${fonts.A};
    line-height: ${fontsLineHeight.A};
    letter-spacing: normal;
    color: #121252;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }

  b {
    font-weight: bold;
    font-size: ${fonts.P};
    letter-spacing: normal !important;
  }


  label {
    font-family: var(--euclid-medium);
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.13;
    letter-spacing: normal;
    color: #121252;

    @media (min-width: ${device.tablet}) and (max-width: ${device.tabletL}) {
      font-size: 26px;
    }

    @media (min-width: ${device.laptop}) {
      font-size: 30px;
    }
  }
  .checkbox {
    display: inline-flex;
    cursor: pointer;
    position: relative;
  }
  
  .checkbox > input {
    height: 17px;
    width: 17px;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    border: 1px solid ${colours.MIDNIGHT_BLUE};
    border-radius: 4px;
    outline: none;
    transition-duration: 0.3s;
    cursor: pointer;
  
    @media (min-width: ${device.tablet}) and (max-width: ${device.desktopS}) {
      height: 20px;
      width: 20px;
    }
  
    @media (min-width: ${device.desktopS}) {
      height: 30px;
      width: 30px;
    }
  
  }
  
  .checkbox > input:checked {
    border: 1px solid ${colours.PEACH};
    background-color: ${colours.PEACH};
  }
  
  .checkbox > input:checked::before {
    content: "\\2713";
    color: ${colours.WHITE};
    font-size: 17px;
    height: 17px;
    width: 17px;
    position: absolute;
    bottom: 2px;
    left: 1px;
  
    @media (min-width: ${device.tablet}) and (max-width: ${device.desktopS}) {
      font-size: 20px;
      height: 20px;
      width: 20px;
    }
  
    @media (min-width: ${device.desktopS}) {
      font-size: 30px;
      height: 30px;
      width: 30px;
    }
  }


  select {
    font-family: var(--euclid-regular)
    outline: none;
    border: none;
    border-bottom: 1px solid ${colours.MIDNIGHT_BLUE};
    color: #121252;
    font-size: 20px;
    background: transparent;

    @media (max-width: ${device.laptop}) {
      height: 38px;
      font-size: 16px;
      padding-bottom: 5px;
    }

    @media (min-width: ${device.laptop}) {
      font-size: 16px;
      padding-bottom: 11px;
      height: 38px;
    }
  }

  .slick-prev, .slick-next {
  font-size: 15px !important;
}

 .slick-prev:before, .slick-next:before  {
  content: '' !important;
}
  .required:after {
    content:"*";
    color: ${colours.MIDNIGHT_BLUE};
  }
  // prevent
  input:-webkit-autofill {
    -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
    -webkit-transition-delay: 9999s;
  }

`;
